import {
    UPDATE_CEK_KARTU_STATE,
    RESET_CEK_KARTU_STATE
} from '../actions/formCekKartuAction'

const initialState = {
    item_id                     : 0,
    id_kartu_anggota            : "",
    nomor_kartu                 : "",
    kesehatan_no_jamkesmas      : "",
    valueDropdownAnggaran       : "",
    valueDropdownAnggota        : "",
    penerima_item               : "",
    tipe_item                   : "",
    kode_kartu                  : "",
    id_kartu_saldo              : "",
    isKartuValid                : false,
    sudahTerdaftar              : false,
    dataAnggaran                : [],
    dataDropdownAnggaran        : [],
    dataKartu                   : null,
    dataAnggota                 : null,
    dataDropdownAnggota         : [],
    isButtonLoading             : false,
    isLoading                   : false,
}

const cekKartuReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case UPDATE_CEK_KARTU_STATE:
            return {
                ...state,
                ...action.payload                
            }

        case RESET_CEK_KARTU_STATE:
            return {
                ...state,
                ...initialState
            }

        default:
            return state;
    }
}

export default cekKartuReducer


// WEBPACK FOOTER //
// ./src/reducers/formCekKartuReducer.js